import { Stack } from '@mui/system';

import { AccessRequestClientModel, AccessStatus } from '@apono/client-app-sdk';

import RevocationTimeCell from '@MyRequests/components/RevocationTimeCell';

import RequestAgain from '@MyRequests/organisms/RequestAgain';
import RevokeRequest from '@MyRequests/organisms/RevokeRequest';

export function RequestFooter({ data }: { data: AccessRequestClientModel }) {
  switch (data.status.status) {
    case AccessStatus.Active:
    case AccessStatus.GRANTED:
    case AccessStatus.Pending:
    case AccessStatus.PENDING:
    case AccessStatus.PendingMFA:
    case AccessStatus.Granting:
    case AccessStatus.APPROVED:
      return (
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
          <RevocationTimeCell revocation_time={data.revocation_time} />
          <RevokeRequest request={data} />
        </Stack>
      );
    case AccessStatus.Rejected:
    case AccessStatus.REJECTED:
    case AccessStatus.Revoked:
    case AccessStatus.EXPIRED:
    case AccessStatus.Failed:
    case AccessStatus.FAILED:
      return (
        <Stack alignItems="center">
          <RequestAgain request={data} />
        </Stack>
      );
  }
}
